import { AUTH_ROUTING } from '@/pages/auth/auth-routing';
import { CART_ROUTING } from '@/pages/cart/cart-routing';
import { HOME_ROUTING } from '@/pages/home/home-routing';
import { ORDER_ROUTING } from '@/pages/order/order-routing';
import { PROFILE_ROUTING } from '@/pages/profile/profile-routing';
import { CREDIT_ROUTING } from '@/pages/credit/credit-routing';
import { NOTIFICATION_ROUTING } from '@/pages/notification/notification-routing';
import { DEPOSIT_ROUTING } from '@/pages/deposit/deposit-routing';
import { PAYSERVICE_ROUTING } from '@/pages/payservice/payservice-routing';
import { TRANSITION_ROUTING } from '@/pages/transition/routing';
import { NONAME_ROUTING } from '@/pages/noname/routing';
import { DASHBOARD_ROUTING } from '@/pages/dashboard/routing';
import { PAYMENT_REQUEST_ROUTING } from '@/pages/payment-request/payment-request-routing';

export default [
    ...HOME_ROUTING,
    ...AUTH_ROUTING,
    ...CART_ROUTING,
    ...ORDER_ROUTING,
    ...PROFILE_ROUTING,
    ...CREDIT_ROUTING,
    ...NOTIFICATION_ROUTING,
    ...DEPOSIT_ROUTING,
    ...PAYSERVICE_ROUTING,
    ...TRANSITION_ROUTING,
    ...DASHBOARD_ROUTING,
    ...PAYMENT_REQUEST_ROUTING,
    ...NONAME_ROUTING
];
